// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"329":"2976312a0e7c102d","346":"9f89454b626514e0","608":"32759a44ac473274","845":"2fe193f6c84e0cc9","872":"e968cd12033143c5"}[chunkId] + ".js";
};